// extracted by css-extract-rspack-plugin
export default {"label":"HealthCheckupInstitution__label--xm180","value":"HealthCheckupInstitution__value--vR1mC"};